"use client";

import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import type { Usable } from "react";
import { HiXMark } from "react-icons/hi2";
import type { ResolvedIntlConfig } from "react-intl";
import { useAnalytics } from "use-analytics";
import type { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { Button } from "@repo/components/atoms/shadcn/button";
import { LoadingDots } from "@repo/components/atoms/loading-dots";
import { BaseCartLine_Fragment } from "#/graphql/shopify-storefront/fragments";
import { CartLinesRemove_Mutation } from "#/graphql/shopify-storefront/mutations";
import { Cart_Query } from "#/graphql/shopify-storefront/queries";
import { fetcherShopifyStorefront, readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { useGetIntl } from "@repo/i18n/intl/client";
import { cn } from "@repo/lib";
export function DeleteItemButton(t0) {
  const $ = _c(30);
  const {
    baseCartLineFragment,
    cartId,
    className,
    dictionaryPromise,
    lang
  } = t0;
  let t1;
  if ($[0] !== dictionaryPromise || $[1] !== lang) {
    t1 = {
      dictionaryPromise,
      lang
    };
    $[0] = dictionaryPromise;
    $[1] = lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const intl = useGetIntl(t1);
  let t2;
  if ($[3] !== baseCartLineFragment) {
    t2 = readFragmentShopifyStorefront(BaseCartLine_Fragment, baseCartLineFragment);
    $[3] = baseCartLineFragment;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const baseCartLine = t2;
  const payload = baseCartLine.id;
  const shopifyQueryClient = useQueryClient();
  let t3;
  if ($[5] !== cartId || $[6] !== shopifyQueryClient) {
    t3 = {
      mutationFn: _temp,
      onSuccess: () => {
        const queryKey = [Cart_Query, {
          cartId
        }];
        shopifyQueryClient.invalidateQueries({
          queryKey
        });
      }
    };
    $[5] = cartId;
    $[6] = shopifyQueryClient;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    isPending,
    mutate,
    status
  } = useMutation(t3);
  const {
    track
  } = useAnalytics() || {};
  let t4;
  if ($[8] !== cartId || $[9] !== isPending || $[10] !== mutate || $[11] !== payload || $[12] !== track) {
    t4 = event => {
      if (isPending) {
        event.preventDefault();
      }
      mutate({
        cartId,
        lineIds: [payload]
      });
      const {
        dataset
      } = event.currentTarget;
      track("remove_from_cart", {
        ...dataset,
        cartId,
        lineIds: [payload]
      });
    };
    $[8] = cartId;
    $[9] = isPending;
    $[10] = mutate;
    $[11] = payload;
    $[12] = track;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const handleClickTrack = t4;
  let t5;
  if ($[14] !== intl) {
    t5 = intl.formatMessage({
      defaultMessage: "Remove",
      description: "Remove",
      id: "sa1shP"
    });
    $[14] = intl;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== className || $[17] !== isPending) {
    t6 = cn(className, {
      "cursor-not-allowed": isPending
    });
    $[16] = className;
    $[17] = isPending;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== isPending) {
    t7 = isPending ? <LoadingDots /> : <HiXMark />;
    $[19] = isPending;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== status) {
    t8 = <span aria-live="polite" className="sr-only" role="status">{status}</span>;
    $[21] = status;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== handleClickTrack || $[24] !== isPending || $[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
    t9 = <Button aria-label={t5} aria-disabled={isPending} className={t6} onClick={handleClickTrack} size="icon" variant="icon">{t7}{t8}</Button>;
    $[23] = handleClickTrack;
    $[24] = isPending;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
}
function _temp(variables) {
  return fetcherShopifyStorefront(CartLinesRemove_Mutation, variables);
}